import { formatBudget } from './format';

/**
 * «С нами уже более N поставщиков» — the number N, or null when the line must
 * not carry a live number at all.
 *
 * The count comes from the public landing stats (`registeredUsersFloor`: unique
 * ИНН among non-internal accounts — companies, not registrations (owner,
 * 14.10.2026) — already rounded down to a hundred by the API). Three rules, in
 * one place so the page cannot apply half of them:
 *
 *  - **Never «более 0».** No answer yet (prerender, first paint), a failed
 *    request, an API older than this field, anything that is not a positive
 *    number → null, and the page keeps its static line.
 *  - **A threshold, not a country check.** Below {@link SOCIAL_PROOF_MIN_USERS}
 *    the number is not social proof — «более 0 поставщиков» on a deployment
 *    with 34 accounts is the opposite of one. The same rule serves every
 *    country build; nothing here knows which one it is.
 *  - **Rounded DOWN to a hundred**, so «более 6 600» stays true for 6 627. The
 *    API already does it; done again here because the claim is made by this
 *    page, and a payload that one day carries the exact figure must not turn
 *    «более» into a lie.
 */
export const SOCIAL_PROOF_MIN_USERS = 500;

const STEP = 100;

export function socialProofCount(registeredUsers: unknown): string | null {
  if (typeof registeredUsers !== 'number' || !Number.isFinite(registeredUsers)) return null;
  if (registeredUsers < SOCIAL_PROOF_MIN_USERS) return null;
  const floor = Math.floor(registeredUsers / STEP) * STEP;
  // Spaced thousands, the same grouping every other number on the page uses —
  // and deliberately not `Intl`: Chrome ships no `uz` number data (see
  // `formatBudgetCompact`), so a locale-aware formatter passes in Node and
  // breaks for a real visitor.
  return formatBudget(String(floor));
}
